export default __webpack_public_path__ + "static/like_dark-07df30ae6d247b958786cf8e34ec3967.svg";